/** Console destinations unavailable when Platform Admin disables Online Store. */
export function onlineOnlyPath(path: string): boolean {
  const pathname = path.split(/[?#]/)[0]?.replace(/\/+$/, '') ?? '';
  return [
    '/online-store',
    '/themes',
    '/blogs',
    '/pages',
    '/forms',
    '/customers/subscribers',
    '/subscribers',
    '/reviews',
    '/navigation',
    '/seo',
    '/assistant',
    '/apps',
    '/media',
    '/payment-methods',
    '/checkout-settings',
    '/settings/notifications',
  ].some((root) => pathname === root || pathname.startsWith(`${root}/`));
}
